import styled from "styled-components";

const Carousel = styled.div`
  position: relative;
  margin: 32px 0;
`;

export { Carousel };
